import store from '@/store';

export function getUploadProgress(progressEvent) {
  if (progressEvent.event.lengthComputable) {
    const totalLength =
      progressEvent.event.lengthComputable ?
        progressEvent.event.total :
        progressEvent.event.target.getResponseHeader('content-length') || progressEvent.event.target.getResponseHeader('x-decompressed-content-length');
    if (totalLength !== null) {
      store.commit('SET_PROGRESS_PERCENTAGE', (Math.round( (progressEvent.event.loaded * 100) / totalLength )));
    }
  }
}

export function setAxiosCsrfHeader() {
  return (name => {
    var re = new RegExp(`(?:^|; )${name}=([^;]+)`); // is `^name` or `; name`
    var value = re.exec(document.cookie);
    return (value != null) ? decodeURIComponent(value[1]) : null;
  })('csrftoken');
}